import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable, catchError, map, of, shareReplay } from 'rxjs';

import { buildInfo } from '@environments/build-info';
import { environment } from '@environments/environment';

/** Versions of the running portal: the SPA build (baked in at build time) and the API (from its anonymous health endpoint). */
@Injectable({ providedIn: 'root' })
export class VersionService {
  private readonly http = inject(HttpClient);

  readonly spaVersion = buildInfo.version;

  /** API build version, or null when the health endpoint is unreachable or reports none. */
  readonly apiVersion$: Observable<string | null> = this.http
    .get<{ version?: string }>(`${environment.apiBaseUrl}/api/health`)
    .pipe(
      map(res => res.version ?? null),
      catchError(() => of(null)),
      shareReplay(1),
    );
}
